import styled from "styled-components";
import { colors } from "./variables";

export const Wrapper = styled.div`
  position: relative;
  height:100%;
  background: ${colors.fogGray};
  .Toastify__toast--warning,
  .Toastify__toast--error {
      font-size: 16px;
      font-weight: 500;
      background-color: #fff;
      color: rgb(105, 105, 105);
      cursor: text;
      border-radius: 4px;
      padding: 10px 20px;
      line-height: 20px;
  }
  .Toastify__toast--error{
    background-color: ${colors.red};
    color: #fff;
  }
  .Toastify__toast--warning {
    background: ${colors.orange};
    color: ${colors.charcoalGray};
  }
  .Toastify__toast--error .Toastify__close-button{
    color: #fff!important;
  }
  .Toastify__close-button{
    color: rgb(105, 105, 105)!important;
  }

`;